import Ajax from '../../../../common/js/Ajax.js';
import Form from '../../../../common/js/form/Form.js';
import TippspielWidget from '../TippspielWidget.js';

export default class RegisterWidget extends TippspielWidget {

	constructor($widget) {
		super($widget);
	}
	
	onLoginReady() {
		Form.onSubmit(this.$widget, action => {
			var $password1 = action.findField('password');
			var $password2 = action.findField('password2');
			if ($password1.val() !== $password2.val()) {
				Form.showFieldError({
					$field: $password2,
					short: 'Passwörter stimmen nicht überein.',
					long: 'Die Passwörter stimmen nicht überein.'
				});
				action.error();
				return;
			}

			Ajax.rpc('/register', {
				name: action.findField('name').val(),
				email: action.findField('email').val(),
				password: $password1.val(),
				remember: action.findField('remember').is(':checked') ? true : false
			}, success => {
				if (success) {
					window.location.href = '/';
				} else {
					action.error('Registrierung fehlgeschlagen');
				}
			}, error => {
				action.error('Registrierung fehlgeschlagen', error);
			});
		});
	}

}
